import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import TwoDBuildingMap from "./TwoDBuildingMap";
import TwoDMapNotation from "./TwoDMapNotation";
import { prepareTwoDMapData } from "../../../action/twoDMap.action";

import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import { jsPDF } from 'jspdf';
import { params, const_var, initialState } from "../../../redux/reducers/reducer";

class TwoDModalBody extends React.Component {
    constructor(props) {
        super(props);
        //console.log("this.props", this.props,const_var.post_data);
      }
      autoDownload = () => {        
        var autoPdf = new jsPDF('p', 'px', 'a4',true,true);
        // console.log(autoPdf);
        if(const_var.post_data?.building !== undefined && const_var.post_data.building)
        {
          if(document.getElementById('autogenerated') != undefined)
          { 
            document.getElementById('autogenerated').style.contentVisibility = "visible";
            //document.getElementById('autogenerated').style.contentVisibility = "visible";        
            var w = document.getElementById('autogenerated').style.width;
            var h = document.getElementById('autogenerated').style.height;
            htmlToImage.toPng(document.getElementById('autogenerated'), { width:w, height:h, quality: 1 })
              .then(function (dataUrl) {           
                const_var.i_g_A_y2d = [];
                const_var.i_g_A_y2d.push({"image":dataUrl,"image_name":"2D Layout"});                
                //console.log(const_var.i_g_A_y2d);
                //var link = document.createElement('a');
                //link.download = '2D-Layout.png';
                //link.href = dataUrl;
                //link.click();
                //console.log(document.getElementById('autogenerated'));               
                // const imgProps= autoPdf.getImageProperties(dataUrl);
                // const pdfWidth = autoPdf.internal.pageSize.getWidth();//500;//
                // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;//550;//
                // var width = autoPdf.internal.pageSize.getWidth();
                // var height = autoPdf.internal.pageSize.getHeight();
                // var widthRatio = width / imgProps.width;
                // var heightRatio = height / imgProps.height;
                // var ratio = widthRatio > heightRatio ? heightRatio : widthRatio;
                // autoPdf.internal.scaleFactor = 10;
                // //console.log(dataUrl,autoPdf,width,imgProps.width,height,imgProps.height,ratio);        
                // autoPdf.addImage(dataUrl, 'PNG', 0, 0,imgProps.width * ratio, imgProps.height * ratio,'null','SLOW',0 );
                // autoPdf.save("2D-Layout.pdf");
                //autoPdf.save("2D-Layout.pdf");
            }); 
          }
        }   
      };
      // componentDidUpdate() {
        //   //this.autoDownload();
      //   //this.props.pdfGenerate.bind(this);
      //   //this.props.pdfGenerate();        
      // }
    render ()
    {
        //console.log("this.props", this.props,this.props.const_var.post_data);
        if(const_var.post_data?.building !== undefined && const_var.post_data.building)
        {
          //this.props.const_var.post_data?.building !== undefined && this.props.const_var.post_data.building && this.props.prepareTwoDMapData(this.props.const_var.post_data.building);  
            return (
                <Fragment>
                {/* <button style={{display:"block"}} className="btn btn-white-shadow twod-map-btn" onClick={this.autoDownload}>
                        <span className="icon icon-download"></span>
                        <span className="text ml-1">Download</span>
                </button> */}
                <div style={{justifyContent: "center" , contentVisibility: "hidden", position: "fixed", width: "100%" }} >
                    <div id ="autogenerated" style={{ display: "none", justifyContent: "center" , flexDirection: "column" }} className="map-inner" ref={(el) => (this.componentRef = el)}>
    
                    <div style={{ display: "flex", justifyContent: "center", fontSize:"16px", marginBottom: "10px",
                    marginTop: "20px"
                    }}><strong>Legends</strong></div>
                    <div className="map-notation" style={{ display: "flex", justifyContent: "center"}}>
                        <TwoDMapNotation />
                    </div>
                    <div className="map-object" style={{ display: "flex", justifyContent: "center"}}>
                        <TwoDBuildingMap purpose="save" />
                    </div>
    
                    </div>
                    {/* <div style={{ visibility: "visible", position:"absolute" }}  id ="autogenerated">Download</div> */}
                </div>             
                </Fragment>            
            )

        }else{
          return null;
        }
    }    
}
const mapDispatchToProps = {
    prepareTwoDMapData,
  };
  const mapStateToProps = (state) => {
    return { ...state.reducer };
  };
export default connect(mapStateToProps, mapDispatchToProps)(TwoDModalBody)
